import type { SxProps, Theme } from '../../themes/themes';

export const getStyles = (theme: Theme): { [key: string]: SxProps } => {
  return {
    'variant:pill': {
      '&.MuiList-root': {
        paddingX: theme.spacing(5),
        listStyle: 'disc',
      },
      '& .MuiListItem-root': {
        display: 'list-item',
        [theme.breakpoints.up('lg')]: {
          //marginLeft: theme.spacing(3),
        },
        '& .MuiListItemText-root': {
          [theme.breakpoints.up('lg')]: {
            paddingLeft: theme.spacing(6),
          },
        },
      },
    },
    'size:small': {
      '& .MuiListItemAvatar-root': {
        paddingRight: theme.spacing(3),
        [theme.breakpoints.up('lg')]: {
          paddingRight: theme.spacing(5),
        },
        '.MuiSvgIcon-root': {
          fontSize: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            fontSize: theme.spacing(6),
          },
        },
      },
      '& .MuiIconButton-root': {
        alignSelf: 'flex-start',
        marginLeft: theme.spacing(3),
        [theme.breakpoints.up('lg')]: {
          marginLeft: theme.spacing(5),
        },
        '.MuiSvgIcon-root': {
          fontSize: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            fontSize: theme.spacing(6),
          },
        },
      },
    },
    'size:medium': {
      '& .MuiListItemAvatar-root': {
        paddingRight: theme.spacing(4),
        [theme.breakpoints.up('lg')]: {
          paddingRight: theme.spacing(7),
        },
        '.MuiSvgIcon-root': {
          fontSize: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            fontSize: theme.spacing(7),
          },
        },
      },
      '& .MuiIconButton-root': {
        alignSelf: 'flex-start',
        marginLeft: theme.spacing(4),
        [theme.breakpoints.up('lg')]: {
          marginLeft: theme.spacing(7),
        },
        '.MuiSvgIcon-root': {
          fontSize: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            fontSize: theme.spacing(7),
          },
        },
      },
    },
    'variant:number': {
      '&.MuiList-root': {
        counterReset: 'listItem',
        display: 'flex',
        flexDirection: 'column',
      },
      '& .MuiListItem-root': {
        counterIncrement: 'listItem',
        '&::before': {
          alignSelf: 'start',
          ...theme.typography.h4,
          minWidth: theme.spacing(7),
          content: 'counter(listItem) "."',
          [theme.breakpoints.up('lg')]: {
            ...theme.typography.h4,
            minWidth: theme.spacing(9),
          },
        },
        '& .MuiListItemText-root': {
          marginY: 0,
          '& .MuiListItemText-secondary': {
            marginBottom: theme.spacing(5),
            [theme.breakpoints.up('md')]: {
              marginBottom: theme.spacing(9),
            },
          },
        },
      },
      '& .MuiListItemAvatar-root': {
        display: 'none',
      },
    },
  };
};
